export const admissionStatus = [
  { id: 0, label: 'Inactive' },
  { id: 1, label: 'Active' },
  { id: 2, label: 'Temporary Inactive' },
];
